export default [
    {
        path: "school/management/holiday",
        name: "holidayList",
        component: () => import("../../components/holiday/HolidaySettingsPage"),
    },
];
